import Keycloak from 'keycloak-js';

const basePath = process.env.ASSET_PATH || './';
const authServerUrl = `${process.env.API_URL}/auth/` || 'https://app.phasetwo.io/auth/';

const keycloakConfig = {
  realm: 'self',
  url: authServerUrl,
  clientId: 'dashboard',
};

// Setup Keycloak instance as needed
const keycloak = new Keycloak(keycloakConfig);

keycloak.onAuthSuccess = function () {
  if (
    keycloak.tokenParsed &&
    'organizations' in keycloak.tokenParsed &&
    Array.isArray(keycloak.tokenParsed['organizations']) &&
    keycloak.tokenParsed['organizations'].length
  ) {
    //do nothing?
  } else {
    //create an org if the user is not already a member of an org
  }
};

setInterval(async () => {
  if (keycloak.isTokenExpired(10)) {
    keycloak.updateToken(10);
  }
}, 5 * 1000); // 5 seconds

export default keycloak;
